import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	({ spacing }) => ({
		root: {
			position: 'absolute',
			top: 0,
			left: 0,
			height: '100%',
			padding: spacing(0.25),
			zipIndex: 0,
			borderRadius: 0,
			cursor: 'grab',
		},
	}),
	{ name: 'Questions-AnswerTypes-DragHandle' },
)

export default useStyles
